'use client';

import { useEffect, useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import Snackbar from '@/components/Snackbar';
import { useConfig } from '@/app/contexts/ConfigContext';
import { useAuth } from '@/app/contexts/AuthContext';

export default function LoginSuccess() {
  const { wording, config } = useConfig();
  const { refreshAuth } = useAuth();

  const params = useSearchParams();

  const isLoginSuccessful = params.get('login') === 'true';
  const [snackbarVisible, setSnackbarVisible] = useState(false);

  useEffect(() => {
    if (!isLoginSuccessful) return;

    if (isLoginSuccessful) {
      refreshAuth();
      setSnackbarVisible(true);

      const t = setTimeout(() => setSnackbarVisible(false), 5000);

      return () => clearTimeout(t);
    }
  }, [isLoginSuccessful, refreshAuth, params]);

  return (
    <Snackbar
      show={snackbarVisible}
      message={wording!.components_login_success_text}
      onClose={() => setSnackbarVisible(false)}
      bgColor={config.theme.accentColorOne}
      textColor={config.theme.textColorDark}
      login
    />
  );
}
